module.exports = __webpack_public_path__ + "static/media/dropdown_icon.dbc8fd17.svg";